module.exports = __webpack_public_path__ + "assets/338607d7833fde0abf18b36759419892.svg";